import { CHAT_NEW_MESSAGE_SOUND_URL } from '@/views/apps/chat-matrix-fast/assets/sounds'
import { soundService } from '@/utils/soundService'
import { getChatNotificationsEnabled } from '@/modules/chat-matrix-fast/utils/chatNotifications'
import { bindChatSystemNotificationPermissionGesture } from '@/modules/chat-matrix-fast/utils/chatSystemNotification'

let soundsConfigured = false

/** Регистрирует звук чата в soundService (один раз). */
export function initChatMessageSounds(): void {
  if (soundsConfigured) {
    return
  }

  soundService.registerSoundFile('new-message', CHAT_NEW_MESSAGE_SOUND_URL)
  soundsConfigured = true
  bindChatSystemNotificationPermissionGesture()
}

/**
 * Воспроизводит звук нового сообщения, если уведомления включены для чата.
 */
export function playChatNewMessageSound(chatId: number | string | null | undefined): void {
  if (!chatId || !getChatNotificationsEnabled(chatId)) {
    return
  }

  initChatMessageSounds()

  soundService.playNewMessageSound().catch(() => {
    // Автоплей может быть заблокирован до первого взаимодействия пользователя
  })
}
